module.exports = ".home.wrapper {\n  padding-top: 10px;\n  background-color: white; }\n  .home.wrapper .breadcrumb {\n    background: #cccccc;\n    color: #333333; }\n  h1 {\n  text-align: center;\n  width: 100%;\n  color: #555;\n  font-weight: 400;\n  font-size: 50px;\n  line-height: 60px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.scss
// module id = ./src/app/components/home/home.component.scss
// module chunks = main